import { UNAUTHENTICATED_ROUTES } from './routes'

export const getPublicSearchLink = searchId =>
  `${process.env.REACT_APP_FRONT_END_HOST}${UNAUTHENTICATED_ROUTES.PUBLIC_SEARCH}?key=${searchId}`

export const isCustomSubdomain = () =>
  typeof process.env.REACT_APP_CUSTOM_SUBDOMAIN !== 'undefined'
